export default "__VITE_ASSET__CF9jF24o__"